import React from 'react';
import { Slices, Redux } from 'spwa-ui-library';
import DialogBox from '../DialogBox';
import DrawerPwa from '../DrawerPwa';
import { FormattedMessage, useIntl } from 'react-intl';
import css from './index.module.scss';
import { Divider, Radio } from '@material-ui/core';

import LockedOrderMode from './images/lockedOrderMode.svg';

import CurbsideIcon from './images/curbside.svg';
import DeliveryIcon from './images/delivery.svg';
import DineInIcon from './images/dinein.svg';
import DriveThruIcon from './images/drivethru.svg';
import PickUp from './images/pickup.svg';

const { useSelector } = Redux;
const { selectDesktop } = Slices.appSlice;

function ChangeOrderModeDialog({
  productId,
  availableModes = [],
  handleOrderModePopup,
  handleOnClick,
}) {
  const intl = useIntl();
  const isDesktop = useSelector(selectDesktop);

  const orderModeMapping = {
    carhop: {
      icon: CurbsideIcon,
      text: 'Curbside',
    },
    delevery: {
      icon: DeliveryIcon,
      text: 'Delivery',
    },
    take_away: {
      icon: PickUp,
      text: 'Pickup',
    },
    dine_in: {
      icon: DineInIcon,
      text: 'DineIn',
    },
    drivethru: {
      icon: DriveThruIcon,
      text: 'Drive-Thru',
    },
  };

  const DialogContent = (
    <div className={css.changeOrderModeContent}>
      <div className={css.changeOrderModeRow1}>
        <img src={LockedOrderMode} />
        <span>
          <FormattedMessage
            id={'change_order_mode_desc'}
            defaultMessage={'Change your order mode to unlock this deal 🤘'}
          />
        </span>
      </div>

      <Divider />

      <div className={css.changeOrderModeRow2}>
        <span className={css.validForText}>
          <FormattedMessage id={'valid_only_for'} defaultMessage={'Valid only for :'} />
        </span>
        <div className={css.orderModeSelection}>
          {availableModes?.map((orderMode, idx) => {
            const data = orderModeMapping[orderMode];
            return (
              <div
                className={css.orderModeBox}
                key={`${orderMode}_${idx}`}
                onClick={() => {
                  handleOnClick(orderMode);
                }}
              >
                <img src={data.icon} alt={data.text} />
                <span className={css.radioContainer}>
                  <Radio />
                  <span className={css.orderModeName}>{` ${data.text}`}</span>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );

  return (
    <>
      {isDesktop ? (
        <DialogBox
          title={intl.formatMessage({ id: 'change_order_mode' })}
          hideCloseButton={true}
          size="md"
          className={css.changeOrderModeDialog}
          isOpen={productId > 0}
          onClose={() => {
            handleOrderModePopup(0);
          }}
        >
          {DialogContent}
        </DialogBox>
      ) : (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          open={productId > 0}
          onClose={() => {
            handleOrderModePopup(0);
          }}
        >
          {DialogContent}
        </DrawerPwa>
      )}
    </>
  );
}

export default ChangeOrderModeDialog;
